import CheckBox from 'components/final-form/CheckBox';
import DatePicker from 'components/final-form/DatePicker';
import Input from 'components/final-form/Input';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import moment from 'moment';
import React from "react";
import { Field } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid } from 'semantic-ui-react';
import { timeValidator } from 'utils/validatorUtils';

interface Props extends MessageSourceProps {
  treatmentDate: string,
  isAfterDate: (value: string) => string | undefined
}

const DateTimeSegment = (props: Props): React.ReactNode => {

  const {treatmentDate, isAfterDate, getMessage} = props;

  const timeInputFormat = (value: any) => {
    if (moment(value, "H:mm").isValid()) {
      return moment(value, "H:mm").format('HH:mm');
    } else {
      return moment().format('HH:mm');
    }
  };

  const timeFormatOnFocus = (value: any) => {
    if (value === "Invalid date") {
      return "";
    }
  };

  return (
      <PraxFormGrid>
        <Grid.Row>
          <Grid.Column width={2} verticalAlign={"middle"}>
            {`${getMessage("date")}:`}
          </Grid.Column>
          <Grid.Column width={4} verticalAlign={"middle"}>
            <Field
                name="consultationDate"
                component={DatePicker}
                disabledBefore={new Date(treatmentDate)}
                emptyDateInput
                validate={isAfterDate}
                fluid
            />
          </Grid.Column>
          <Grid.Column width={2} verticalAlign={"middle"}>
            {`${getMessage("time")}:`}
          </Grid.Column>
          <Grid.Column width={3} verticalAlign={"middle"}>
            <Field
                name="consultationTime"
                component={Input}
                validate={timeValidator}
                onFocus={(value: any) => timeFormatOnFocus(value)}
                format={(value: any) => timeInputFormat(value)}
                formatOnBlur
                fluid
            />
          </Grid.Column>
          <Grid.Column width={5} verticalAlign={"middle"}>
            <Field
                name="holiday"
                component={CheckBox}
                label={getMessage("consultation.holiday")}
            />
          </Grid.Column>
        </Grid.Row>
      </PraxFormGrid>
  );
};


export default withMessages(DateTimeSegment);
